/**
 * This file contains a list of regular expressions for different parts of the application
 */

/**
 * regular expression for user name
 * can only contain letters, dashes, spaces, and apostrophes
 *
 * @type {RegExp}
 */
export const userNameRegex = /^[A-Za-z- ']+$/;

/**
 * regular expression for password
 * password must contain at least 3 of the following: uppercase letter, lowercase letter, digit, special character
 *
 * @type {RegExp}
 */
export const userPasswordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*$/;

/**
 * regular expression for group name
 * can only contain letters, numbers, spaces, dashes, underscores, and '&'
 *
 * @type {RegExp}
 */
export const groupNameRegex = /^[\s\S]+$/;
